import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { OnboardSquadsApi } from './onboardSquadsApi';

export class OnboardSquadsClient implements OnboardSquadsApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async addUserToSquad(
    userToken: string,
    filePath: string,
    memberEntity: string,
  ): Promise<any> {
    const baseUrl = await this.discoveryApi.getBaseUrl('onboard-squads');
    const response = await this.fetchApi.fetch(`${baseUrl}/add-user-to-squad`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userToken,
        filePath,
        memberEntity,
      }),
    });
    if (!response.ok) {
      throw new Error(`Failed to add user to squad: ${response.statusText}`);
    }
    const result = await response.json();
    return result;
  }

  async deleteUserFromSquad(
    userToken: string,
    filePath: string,
    memberEntity: string,
  ): Promise<any> {
    const baseUrl = await this.discoveryApi.getBaseUrl('onboard-squads');
    const response = await this.fetchApi.fetch(
      `${baseUrl}/delete-user-from-squad`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userToken,
          filePath,
          memberEntity,
        }),
      },
    );
    if (!response.ok) {
      throw new Error(`Failed to add user to squad: ${response.statusText}`);
    }
    return await response.json();
  }
}
